import type { ReactNode } from 'react';
import { Info } from 'lucide-react';
import { DeltaChip } from './Badge.js';
import './stat-card.css';

interface StatCardProps {
  icon: ReactNode;
  label: string;
  value: string;
  /** One plain sentence saying what the figure counts, read without hovering. */
  definition?: string;
  deltaRatio?: number | null;
  hint?: string;
  lowConfidence?: boolean;
}

/** KPI tile: icon + label, one large figure, a delta chip beside it, its definition under it. */
export function StatCard({
  icon,
  label,
  value,
  definition,
  deltaRatio = null,
  hint,
  lowConfidence,
}: StatCardProps) {
  return (
    <article className="stat">
      <header className="stat__head">
        <span className="stat__icon">{icon}</span>
        <span className="stat__label">{label}</span>
        {hint && (
          <span className="stat__hint" title={hint} aria-label={hint}>
            <Info size={13} />
          </span>
        )}
      </header>
      <div className="stat__row">
        <span className="stat__value">{value}</span>
        <DeltaChip ratio={deltaRatio} />
      </div>
      {definition && <p className="stat__definition">{definition}</p>}
      {lowConfidence && <p className="stat__note">Peu d'usagers mesurés : chiffre à lire avec prudence</p>}
    </article>
  );
}
